// Główny panel kontrolny dla interfejsu noclegów

import React from "react";
// import { useAccommodation } from "../../AccommodationProvider";
import DayNavigation from "./DayNavigation";
import GuestStructure from "./GuestStructure";
import ActionButtons from "./ActionButtons";

const ControlPanel: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-6 text-center">
        Panel Kontrolny
      </h3>

      {/* Layout responsywny - na desktop wszystko w jednym rzędzie, na mobile w kolumnach */}
      <div className="space-y-6 lg:space-y-4">
        {/* Nawigacja dni */}
        <DayNavigation />

        {/* Scalona tabela - struktura i przypisania */}
        <div>
          <h4 className="text-sm font-medium text-gray-700 mb-3">
            Struktura i przypisania
          </h4>
          <GuestStructure />
        </div>

        {/* Przyciski akcji */}
        <ActionButtons />
      </div>
    </div>
  );
};

export default ControlPanel;
